// extracted by mini-css-extract-plugin
export default {"component_ig":"Breadcrumbs__component_ig--ig-gka8x","item_ig":"Breadcrumbs__item_ig--ig-INL9z","active_ig":"Breadcrumbs__active_ig--ig-OkASA Breadcrumbs__component_ig--ig-gka8x"};